import { Button } from '@/components/ui/button'

/**
 * Answers the agent offers in place of typing. Built on outlineThin, whose
 * one-pixel stroke and brand/15 hover are already what a quiet, pickable
 * answer wants; the text drops to the chat's own size so an option reads as
 * part of the conversation rather than a control beside it.
 *
 * Layout belongs to the caller — MessageList's trailing slot stacks them.
 */
export function ChatOptions({
  options,
  onSelect,
}: {
  options: string[]
  onSelect: (option: string) => void
}) {
  return options.map((option) => (
    <Button
      key={option}
      type="button"
      variant="outlineThin"
      size="sm"
      className="text-xs"
      onClick={() => onSelect(option)}
    >
      {option}
    </Button>
  ))
}
